import React from "react";
import { useState, useEffect } from "react";
import BoostrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { PageOptions } from "../../components/PageParams";
import { useSelector } from "react-redux";
import { HttpJsonHeader } from "../../../features/Environments";
import {
  Button,
  Badge,
  OverlayTrigger,
  Tooltip,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import axios from "axios";
import { AiFillEdit, AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";
import CompanyPopup from "./CompanyPopup";
import { SerachBox } from "../../components/SerachBox";

import ConfirmDialog, { GetConfirmTitle } from "../../components/ConfirmDialog";

export default function Company() {
  const userDetail = useSelector((state) => state.user.detail);
  const [data, setData] = useState([]);
  const [fields, setFields] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [updateFlag, setUpdateFlag] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);

  const props = {
    show: popupVisible,
    fields: fields,
    hidePopup: () => {
      setPopupVisible(false);
    },
    setUpdate: setUpdateFlag,
    user: userDetail,
  };
  useEffect(() => {
    if (updateFlag) {
      getData();
      setUpdateFlag(false);
    }
  }, [updateFlag]);

  // RELOAD DATA
  const getData = () => {
    axios
      .post(
        process.env.REACT_APP_API + "api/company/select",
        {},
        HttpJsonHeader
      )
      .then((response) => {
        setData(response.data.lists);
      })
      .catch((err) => alert(err));
  };

  //**  NEW DATA   */
  const popupNew = () => {
    setFields(null);
    setPopupVisible(true);
  };

  //**  UPDATE  */
  const popupData = (row) => {
    setFields(row);
    setPopupVisible(true);
  };

  //**  DELETE  */
  const popupDelete = (row) => {
    setShowConfirm(true);
    setConfirmAction({
      title: GetConfirmTitle("DELETE"),
      data: row,
      action: (data) => {
        axios
          .post(
            process.env.REACT_APP_API + "api/company/delete",
            data,
            HttpJsonHeader
          )
          .then((res) => {
            setUpdateFlag(true);
          })
          .catch((err) => console.log(err));
      },
    });
  };

  const formatEditBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>แก้ไข</Tooltip>}
        >
          <Button
            variant="info"
            className="info-button"
            onClick={() => popupData(row)}
          >
            <AiFillEdit />
          </Button>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>ลบ</Tooltip>}
        >
          <Button
            variant="danger"
            className="info-button"
            onClick={() => {
              popupDelete(row);
            }}
          >
            <AiOutlineDelete />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };

  const columns = [
    {
      dataField: "compcode",
      text: "รหัส",
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
      style: { border: "none", color: "var(--table-text-color)" },
    },
    {
      dataField: "compname_th",
      text: "ชื่อกิจการ",
      sort: true,
      style: { border: "none", color: "var(--table-text-color)" },
    },
    {
      dataField: "compname_en",
      text: "English Name",
      sort: true,
      style: { border: "none", color: "var(--table-text-color)" },
    },
    {
      dataField: "compshort",
      text: "ชื่อสั้น",
      sort: true,
      headerStyle: () => {
        return { width: "15%" };
      },
      style: { border: "none", color: "var(--table-text-color)" },
    },
    {
      dataField: null,
      text: "",
      headerStyle: () => {
        return { width: "105px" };
      },
      formatter: formatEditBox,
      align: "center",
    },
  ];

  return (
    <>
      <div>
        <div className="table-caption-box">
          <OverlayTrigger
            placement="top"
            overlay={(props) => <Tooltip {...props}>เพิ่มข้อมูลใหม่</Tooltip>}
          >
            <Button variant="primary" onClick={popupNew}>
              <AiOutlinePlus /> เพิ่มข้อมูลใหม่
            </Button>
          </OverlayTrigger>
          <div className="table-caption-box-right-flex">ข้อมูลกิจการ</div>
          <SerachBox />
        </div>

        <BoostrapTable
          bootstrap4
          keyField="compid"
          rowClasses={"table-next-rows-style"}
          headerWrapperClasses="headerWrapper"
          wrapperClasses="bs-table-wrapper"
          data={data}
          columns={columns}
          striped
          hover
          condensed
          bordered={true}
          pagination={paginationFactory(PageOptions)}
          variant="dark"
        />
      </div>
      <CompanyPopup props={props} />
      <ConfirmDialog
        {...{ showConfirm, setShowConfirm, confirmAction, setConfirmAction }}
      />
    </>
  );
}
